module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAUCAYAAAD2rd/BAAAAAXNSR0IArs4c6QAAAJ9JREFUSEtjZKAx0Jj2ej/DX4bGG7miB6hhFSM1DMFnhsbUV//B8oyMB6jhcPo5GOYrCh1OfwdT6PCBczCZDh94B5Po8MHjYCIdzgjPxbQuLkg1H0fmHLwOxhHig9/BaA4fdTCpSZWgerS0PHhDeMhkOgJV9+Aph4lsYwy8g4l0KLywIJjoKVSAs2Ii0aED52AyHUp/B1PoUPo5mMpdJAC+tIXhX94LmwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qtape/t5.png
// module id = uulW
// module chunks = 1